import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class StripeCharge extends BaseModel {
  public id: string;

  public created: number;

  constructor(model: Partial<StripeCharge> = {}) {
    super();

    this.id = model.id as string;
    this.created = model.created as number;
  }
}
